import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';

/**
 * Bottom Navigation Bar for PWA
 * App-like navigation for mobile devices
 */
function BottomNav({ token }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="bottom-nav">
      <button 
        className={`bottom-nav-item ${isActive('/') ? 'active' : ''}`}
        onClick={() => navigate('/')}
        aria-label="Home"
      >
        <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span className="bottom-nav-label">Home</span>
      </button>

      <button 
        className={`bottom-nav-item ${isActive('/qrcode-generator') ? 'active' : ''}`}
        onClick={() => navigate('/qrcode-generator')}
        aria-label="Gerar QR Code"
      >
        <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7"/>
          <rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/>
          <rect x="3" y="14" width="7" height="7"/>
        </svg>
        <span className="bottom-nav-label">Gerar QR</span>
      </button>

      <button 
        className={`bottom-nav-item ${isActive('/faq') ? 'active' : ''}`}
        onClick={() => navigate('/faq')}
        aria-label="FAQ"
      >
        <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <span className="bottom-nav-label">FAQ</span>
      </button>

      <button 
        className={`bottom-nav-item ${isActive('/contato') ? 'active' : ''}`}
        onClick={() => navigate('/contato')}
        aria-label="Contato"
      >
        <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        <span className="bottom-nav-label">Contato</span>
      </button>

      <button 
        className={`bottom-nav-item ${isActive(token ? '/minha-conta' : '/connect') ? 'active' : ''}`}
        onClick={() => navigate(token ? '/minha-conta' : '/connect')}
        aria-label={token ? "Minha Conta" : "Entrar"}
      >
        {token ? (
          <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        ) : (
          <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
            <polyline points="10 17 15 12 10 7"/>
            <line x1="15" y1="12" x2="3" y2="12"/>
          </svg>
        )}
        <span className="bottom-nav-label">{token ? 'Conta' : 'Entrar'}</span>
      </button>
    </nav>
  );
}

export default BottomNav;
